import { Colors } from 'libs/ui/theme';

import { SvgIcon } from '../SvgIcon';
import { SvgProps } from '../types';

export const Mail = ({
  size = 24,
  color = Colors.black,
  className,
}: SvgProps) => (
  <SvgIcon className={className} size={size}>
    <svg
      color={color}
      fill="none"
      height="16"
      viewBox="0 0 16 16"
      width="16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.9987 3.33366L7.18011 7.36365C7.66159 7.73813 8.3358 7.73813 8.81729 7.36365L13.9987 3.33366M3.46536 13.3337H12.532C13.2788 13.3337 13.6521 13.3337 13.9374 13.1883C14.1882 13.0605 14.3922 12.8565 14.52 12.6056C14.6654 12.3204 14.6654 11.9471 14.6654 11.2003V4.80033C14.6654 4.05359 14.6654 3.68022 14.52 3.395C14.3922 3.14412 14.1882 2.94015 13.9374 2.81232C13.6521 2.66699 13.2788 2.66699 12.532 2.66699H3.46536C2.71863 2.66699 2.34526 2.66699 2.06004 2.81232C1.80916 2.94015 1.60519 3.14412 1.47736 3.395C1.33203 3.68022 1.33203 4.05359 1.33203 4.80033V11.2003C1.33203 11.9471 1.33203 12.3204 1.47736 12.6056C1.60519 12.8565 1.80916 13.0605 2.06004 13.1883C2.34526 13.3337 2.71863 13.3337 3.46536 13.3337Z"
        stroke="currentColor"
      />
    </svg>
  </SvgIcon>
);
